import { CardTypeEnum, ICard } from '@varo/graphql-schema-types';
import { useFocusEffect, usePathname, useRouter } from 'expo-router';
import { useFetchCardDetails } from 'features/cardManagement/hooks/useFetchCardDetails';
import React, { useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import LoadingSpinner from 'shared/components/vxl/loading/LoadingSpinner/LoadingSpinner';
import theme from 'shared/styles/theme';

const debit = 'debit';
const believe = 'believe';

const CardNavigator = () => {
  const router = useRouter();
  const { sourceData, fetching } = useFetchCardDetails();
  const pathName = usePathname();

  const getCardType = () => {
    if (pathName.toLowerCase().includes(debit)) {
      return CardTypeEnum.DebitCard;
    } else if (pathName.toLowerCase().includes(believe)) {
      return CardTypeEnum.ChargeCard;
    }
  };

  const cardType = getCardType();

  const cardId =
    sourceData?.cards?.find((card: ICard) => card.type === getCardType())?.id ??
    undefined;

  useFocusEffect(
    useCallback(() => {
      if (!fetching) {
        if (!cardId) {
          router.replace({
            pathname: '/',
          });
        } else {
          router.replace({
            pathname: '/myvaro/card/[cardId]',
            params: {
              cardId: cardId,
              cardType: cardType,
              defaultSuccess: 'yes',
            },
          });
        }
      }
    }, [cardId, fetching, cardType, router]),
  );

  return (
    <View style={styles.loaderContainer} testID="loader">
      <LoadingSpinner />
    </View>
  );
};

const styles = StyleSheet.create({
  loaderContainer: {
    alignItems: 'center',
    backgroundColor: theme.color.background.primary,
    flex: 1,
    justifyContent: 'center',
    padding: theme.spacing.m,
  },
});

export default CardNavigator;
